import React from "react";
import {BreadCrumbItem} from "../../organisms/HeaderSection";
import Page from "../../organisms/Page";
import FormSection from "./FormSection";

const breadCrumbs: BreadCrumbItem[] = [
    {
        path: "/",
        label: "Inicio"
    },
    {
        path: "/mascotas",
        label: "Mascotas",
    },
    {
        path: "/editar",
        label: "Editar",
        isActive: true
    }
]

function EditarMascota(){
    return (
        <Page title="Edición de Mascota" description="Modificación de datos de mascota." breadCrumbs={breadCrumbs}>
            <FormSection />
        </Page>
    );
}

export default EditarMascota;